import {
  AssemblyType,
  AssemblyTypeKey,
  AssemblyTypeValue,
  JobFormDataInput,
} from '@ecosconnect/core/src/types/jobFormData';
import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { gql } from '@/modes/common/gql';
import { AssemblyInfo } from '@/components/Job/queries';
import { AssemblyInfo as BackflowAssemblyInfo } from '@/components/BackflowTest/queries';

const GET_MODEL_INFO = gql(`
  query GetAssemblyModel($id: Int) {
    backflowAssemblyModels(where: { id: $id }) {
      id
      name
      backflowAssemblyMake {
        id
        name
      }
    }
  }
`);

const useFormAssembly = <AssemblyInfoT = (AssemblyInfo | BackflowAssemblyInfo)>(
  formData?: JobFormDataInput,
  backflowAssembly?: AssemblyInfoT & { id: string }
): AssemblyInfoT | undefined => {
  const { loading: modelLoading, data: modelData } = useQuery(GET_MODEL_INFO, {
    skip: formData?.installationStatus === 3 || !formData?.backflowAssembly,
    variables: { id: formData?.backflowAssembly?.modelId },
  });

  return useMemo(() => {
    if (formData?.installationStatus === 3 || modelLoading) {
      return undefined;
    }

    if (!formData?.backflowAssembly) {
      return backflowAssembly;
    }

    const model = modelData?.backflowAssemblyModels?.[0];
    let type = undefined as AssemblyTypeKey | undefined;
    if (formData.backflowAssembly.type) {
      for (type in AssemblyType) {
        if (
          type &&
          AssemblyType[type] ===
            (formData.backflowAssembly.type as AssemblyTypeValue)
        )
          break;
      }
    }

    return {
      ...formData.backflowAssembly,
      id: backflowAssembly?.id,
      type,
      model,
      size: formData.backflowAssembly.size
        ? typeof formData.backflowAssembly.size === 'string'
          ? parseFloat(formData.backflowAssembly.size)
          : formData.backflowAssembly.size
        : undefined,
    } as AssemblyInfoT;
  }, [
    formData?.installationStatus,
    modelLoading,
    modelData,
    formData?.backflowAssembly,
    backflowAssembly,
  ]);
};

export default useFormAssembly;
